"use client";

import { c as _c } from "react/compiler-runtime";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { useMyStreamOptional } from "@/contexts/wave/MyStreamContext";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { getCopiedDropLink } from "@/helpers/waves/drop-copy-link.helpers";
import { isWaveDirectMessage } from "@/helpers/waves/wave.helpers";
import { useEffect, useRef, useState } from "react";
import type { MouseEvent } from "react";
interface WaveDropMobileMenuCopyLinkProps {
  readonly drop: ApiDrop;
  readonly onCopy: () => void;
}
export default function WaveDropMobileMenuCopyLink(t0) {
  const $ = _c(22);
  const {
    drop,
    onCopy
  } = t0;
  const [copied, setCopied] = useState(false);
  const copiedResetTimeoutRef = useRef(null);
  const isMountedRef = useRef(true);
  const {
    isMemesWave,
    isQuorumWave
  } = useSeizeSettings();
  const myStream = useMyStreamOptional();
  let t1;
  if ($[0] !== myStream?.directMessages.list) {
    t1 = myStream?.directMessages.list ?? [];
    $[0] = myStream?.directMessages.list;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const directMessageWaves = t1;
  let t2;
  if ($[2] !== drop.id) {
    t2 = drop.id.startsWith("temp-");
    $[2] = drop.id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isTemporaryDrop = t2;
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      isMountedRef.current = true;
      return () => {
        isMountedRef.current = false;
        if (copiedResetTimeoutRef.current !== null) {
          globalThis.clearTimeout(copiedResetTimeoutRef.current);
        }
      };
    };
    t4 = [];
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== directMessageWaves || $[7] !== drop || $[8] !== isMemesWave || $[9] !== isQuorumWave || $[10] !== isTemporaryDrop || $[11] !== onCopy) {
    t5 = event => {
      event.stopPropagation();
      if (isTemporaryDrop) {
        return;
      }
      const clipboard = globalThis.navigator.clipboard as {
        writeText?: (text: string) => Promise<void>;
      } | undefined;
      if (typeof clipboard?.writeText !== "function") {
        onCopy();
        return;
      }
      const waveDetails = drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      };
      const dropLink = getCopiedDropLink({
        drop,
        isDirectMessage: isWaveDirectMessage(drop.wave.id, waveDetails, directMessageWaves),
        isMemesWave,
        isQuorumWave
      });
      clipboard.writeText(dropLink).then(() => {
        if (!isMountedRef.current) {
          return;
        }
        setCopied(true);
        onCopy();
        if (copiedResetTimeoutRef.current !== null) {
          globalThis.clearTimeout(copiedResetTimeoutRef.current);
        }
        copiedResetTimeoutRef.current = globalThis.setTimeout(() => {
          if (isMountedRef.current) {
            setCopied(false);
            copiedResetTimeoutRef.current = null;
          }
        }, 2000);
      }).catch(() => {
        onCopy();
      });
    };
    $[6] = directMessageWaves;
    $[7] = drop;
    $[8] = isMemesWave;
    $[9] = isQuorumWave;
    $[10] = isTemporaryDrop;
    $[11] = onCopy;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const copyToClipboard = t5;
  const t6 = `tw-flex tw-items-center tw-gap-x-4 tw-rounded-xl tw-border-0 tw-bg-iron-950 tw-p-4 ${isTemporaryDrop ? "tw-cursor-default tw-opacity-50" : "active:tw-bg-iron-800"} tw-transition-colors tw-duration-200`;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-300" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" /></svg>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `tw-text-base tw-font-semibold ${copied ? "tw-text-primary-400" : "tw-text-iron-300"}`;
  const t9 = copied ? "Copied!" : "Copy link";
  let t10;
  if ($[14] !== t8 || $[15] !== t9) {
    t10 = <span className={t8}>{t9}</span>;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== copyToClipboard || $[18] !== isTemporaryDrop || $[19] !== t10 || $[20] !== t6) {
    t11 = <button type="button" className={t6} onClick={copyToClipboard} disabled={isTemporaryDrop}>{t7}{t10}</button>;
    $[17] = copyToClipboard;
    $[18] = isTemporaryDrop;
    $[19] = t10;
    $[20] = t6;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
}